<div
  *ngIf="
    (transactionInfo?.logoUrl || domain.logoExists) &&
      routeService.isInitialized$ | async
  "
  class="theme-logo logo"
>
  <img
    *ngIf="authService.isAuthorized$ | async"
    [src]="logoUrl"
    [alt]="domain.name + ' logo'"
  />
</div>
<div class="capsule">
  <div class="capsule-content">
    <div *ngIf="routeService.isInitialized$ | async">
      <ng-container *ngIf="authService.isAuthorized$ | async">
        <app-header *ngIf="headerType === 'v1'"></app-header>
        <app-header-v2 *ngIf="headerType === 'v2'"></app-header-v2>
      </ng-container>
    </div>
    <app-alert></app-alert>
    <router-outlet></router-outlet>
  </div>
</div>
